import { apiClient } from './axios';

import type {
  TwilioAssignInboundNumberDto,
  TwilioAvailableNumbersQuery,
  TwilioAvailablePhoneNumber,
  TwilioNumberSyncResponse,
  TwilioPhoneNumber,
  TwilioPurchasePhoneNumberDto,
  TwilioUpdateRegionDto,
} from '@repo/shared-types';

export const twilioNumbersApi = {
  list: async (): Promise<TwilioPhoneNumber[]> => {
    const response = await apiClient.get<TwilioPhoneNumber[]>('/twilio/numbers');
    return response.data;
  },

  sync: async (): Promise<TwilioNumberSyncResponse> => {
    const response = await apiClient.post<TwilioNumberSyncResponse>('/twilio/numbers/sync');
    return response.data;
  },

  getAvailable: async (
    params: Partial<TwilioAvailableNumbersQuery>,
  ): Promise<TwilioAvailablePhoneNumber[]> => {
    const response = await apiClient.get<TwilioAvailablePhoneNumber[]>(
      '/twilio/numbers/available',
      {
        params,
      },
    );
    return response.data;
  },

  purchase: async (payload: TwilioPurchasePhoneNumberDto): Promise<TwilioPhoneNumber> => {
    const response = await apiClient.post<TwilioPhoneNumber>('/twilio/numbers/purchase', payload);
    return response.data;
  },

  assignInbound: async (
    numberId: string,
    payload: TwilioAssignInboundNumberDto,
  ): Promise<TwilioPhoneNumber> => {
    const response = await apiClient.patch<TwilioPhoneNumber>(
      `/twilio/numbers/${numberId}/assign-inbound`,
      payload,
    );
    return response.data;
  },

  updateRegion: async (
    numberId: string,
    payload: TwilioUpdateRegionDto,
  ): Promise<TwilioPhoneNumber> => {
    const response = await apiClient.patch<TwilioPhoneNumber>(
      `/twilio/numbers/${numberId}/region`,
      payload,
    );
    return response.data;
  },
};
